import { dataEqual } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEqual = /*#__PURE__*/createIcon(dataEqual)
export default IconEqual
